// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ViewUI from 'view-design'
import ElementUI from 'element-ui'
import Vuex from 'vuex'
import 'element-ui/lib/theme-chalk/index.css'
import 'view-design/dist/styles/iview.css'
import 'lib-flexible/flexible'
/* swiper */
import 'swiper/dist/css/swiper.min.css';

// 公共样式
import './assets/css/index.css'

/* 重置样式 */
import './assets/css/reset.min.css'

/* animate.css */
import 'animate.css'

// 字体样式
import './assets/fonts/font.css'

/* 路由 */
import router from './router'

/* axios */
import axios from './api'
import api from './api/api'
import store from './store'
import i18n from './assets/i18n/index'


//页面跳转Loading
import routerLoading from './components/loading/index'

Vue.use(ViewUI)
Vue.use(ElementUI)
Vue.use(Vuex)

Vue.prototype.http = axios;
Vue.prototype.api = api;
Vue.prototype.$store = store

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    routerLoading.loadingShow();
    if(to.meta.title){
      document.title = to.meta.title
    }

    setTimeout(function(){
      next();

      setTimeout(function(){
        routerLoading.loadingHide();
      },400)
    },400)

});

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js